import React, { memo } from 'react'
import useFetch from '@alobato/use-fetch'
import CircularProgress from '@alobato/circular-progress'
import { Formik } from 'formik'
import * as Yup from 'yup'
import '../../validators'

import FormModal from '../../components/FormModal'
import Form from './Form'
import useCatalogos from '../../hooks/useCatalogos'
import { enviarCadastro } from '../../lib/enviarCadastro'

import AUTH_TOKEN from '../../constants/authToken'
import BASE_API from '../../constants/baseApi'
import { valorDeGenero } from '../../constants/genero'

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  cpf: Yup.string().matches(/^[0-9]*$/, 'Somente números')
})

/* A API devolve as FKs como objeto aninhado ({id, name}); o formulário precisa
   do id. `?.` não existe no build do CRA desta versão, então a leitura é
   defensiva na mão. */
const idDe = valor => {
  if (valor === null || valor === undefined) return ''
  if (typeof valor === 'object') return valor.id || ''
  return valor
}

/** Catálogo aninhado vira texto com um item por linha, que é o que o campo mostra. */
const linhasDe = lista =>
  (Array.isArray(lista) ? lista : []).map(i => i.name).join('\n')

const Edit = memo(({ id, data, onRequestClose, onUpdated, constantes, planos }) => {
  const initialValues = {
    name: data.name || '',
    login: data.login || data.email || '',
    cpf: data.cpf || '',
    birth_date: data.birth_date || '',
    cellphone: data.cellphone || '',
    gender: valorDeGenero(data.gender),
    orientation: idDe(data.orientation),
    ethnicity: idDe(data.ethnicity),
    health_insurance: idDe(data.health_insurance),
    other_health_insurance: data.other_health_insurance || '',
    blood_type: idDe(data.blood_type),
    rh_factor: idDe(data.rh_factor),
    alimentation: idDe(data.alimentation),
    physical_activity: idDe(data.physical_activity),
    smoke: idDe(data.smoke),
    alcohol: idDe(data.alcohol),
    drug: idDe(data.drug),
    allergies: linhasDe(data.allergies),
    family_history: linhasDe(data.family_history),
    continuous_medications: linhasDe(data.continuous_medications)
  }

  const handleSubmit = async (values, actions) => {
    const salvou = await enviarCadastro({
      url: `${BASE_API}/patient?id=${id}`, method: 'PATCH', values, actions
    })
    if (!salvou) return
    onUpdated()
    onRequestClose()
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
      render={props => (
        <FormModal title='Editar Paciente' onRequestClose={onRequestClose}
          onSubmit={props.handleSubmit} submitting={props.isSubmitting} error={props.status}>
          <Form {...props} constantes={constantes} planos={planos} />
        </FormModal>
      )}
    />
  )
})

export default memo(props => {
  const { data, error, loading } = useFetch(
    `${BASE_API}/patient?id=${props.id}&storage=false`,
    { headers: { Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}` } }
  )
  const catalogos = useCatalogos({ constantes: true })

  if (error) return `Erro! ${error.message}`
  if (!data || loading || catalogos.carregando) {
    return <CircularProgress color='hsla(199, 75%, 43%, 1)' />
  }
  return (
    <Edit {...props} data={data}
      constantes={catalogos.constantes} planos={catalogos.planos} />
  )
})
